import Vue from 'vue'

import moment from 'moment-timezone'
import $ from 'jquery'
import axios from 'axios'
import image2base64 from 'image-to-base64'
import Toasted from 'vue-toasted'
import VueSocketIO from 'vue-socket.io'

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

// Register components in your 'main.js'
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

import 'bootstrap'
import '@fortawesome/fontawesome-free'

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
moment.tz.setDefault('Asia/Jakarta')

window.$ = $
window.axios = axios
window.image2base64 = image2base64
window.moment = moment
window.base_url = 'https://qontraq-api.quantumtri.com'
window.base_online_test_url = 'http://helperq-test.quantumtri.com'

window.axios.defaults.headers['Authorization'] = localStorage.token
window.axios.defaults.headers['Content-Type'] = 'application/json'

Vue.use(Toasted, {
  position: 'top-right',
  duration: 5000,
})

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: 'https://helperq-lumen.quantumtri.com:6010',
// }))

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
